import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./SmartBoardList.css";

const SmartBoardList = () => {
  const [topics, setTopics] = useState([]);
  const [newTopic, setNewTopic] = useState({
    title: "",
    slug: "",
    video: "",
    music: "",
    lyrics: [],
    gameType: "",
    titleImage: "",
    standardNumber: "",
    description: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTopic((prev) => ({
      ...prev,
      [name]: name === "slug" ? value.toLowerCase().replace(/\s+/g, "") : value,
    }));
  };

  const handleTitleChange = (e) => {
    const title = e.target.value;
    setNewTopic((prev) => ({
      ...prev,
      title,
      slug: title.toLowerCase().replace(/\s+/g, ""),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const topicData = {
      ...newTopic,
      standardNumber: "",
      description: "",
    };

    try {
      await addDoc(collection(db, "smartBoardList"), topicData);
      setTopics([...topics, topicData]);
      setNewTopic({
        title: "",
        slug: "",
        video: "",
        music: "",
        lyrics: [],
        gameType: "",
        titleImage: "",
        standardNumber: "",
        description: "",
      });
      setIsEditing(false);
    } catch (error) {
      console.error("Error saving topic:", error);
    }
  };

  const handleAddTopicClick = () => {
    setNewTopic({
      title: "",
      slug: "",
      video: "",
      music: "",
      lyrics: [],
      gameType: "",
      titleImage: "",
      standardNumber: "",
      description: "",
    });
    setIsEditing(true);
  };

  const formatTopicDetails = (topic) => {
    return {
      title: topic.title, // No quotation marks around the key
      slug: topic.slug,
      standardNumber: topic.standardNumber,
      description: topic.description + "", // Add comma after description
      video: topic.video,
      music: topic.music,
      lyrics: [
        ...topic.lyrics.map((line) =>
          line.trim().replace(/^"|"$/g, "").replace(/\\"/g, "").replace(/",?$/, "")
        ),
      ],
      gameType: topic.gameType,
      titleImage: topic.titleImage,
    };
  };

  const handleDetailsClick = (topic) => {
    const formattedTopic = formatTopicDetails(topic);
    setSelectedTopic(formattedTopic);
  };

  const handleCloseDetails = () => {
    setSelectedTopic(null);
  };

  return (
    <div className="topics-container">
      <button className="blue-button" onClick={handleAddTopicClick}>
        Add Topic
      </button>
      {isEditing && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Add Topic</h3>
            <form className="form-container" onSubmit={handleSubmit}>
              <label>Title:</label>
              <input
                type="text"
                name="title"
                value={newTopic.title}
                onChange={handleTitleChange}
                required
              />
              <label>Slug:</label>
              <input
                type="text"
                name="slug"
                value={newTopic.slug}
                onChange={handleInputChange}
                required
              />
              <label>Video:</label>
              <input
                type="text"
                name="video"
                value={newTopic.video}
                onChange={handleInputChange}
              />
              <label>Music:</label>
              <input
                type="text"
                name="music"
                value={newTopic.music}
                onChange={handleInputChange}
              />
              <label>Lyrics:</label>
              <textarea
                name="lyrics"
                value={newTopic.lyrics.join("\n")}
                onChange={(e) =>
                  setNewTopic((prev) => ({
                    ...prev,
                    lyrics: e.target.value.split("\n"),
                  }))
                }
              ></textarea>
              <label>Game Type:</label>
              <select
                name="gameType"
                value={newTopic.gameType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Game Type</option>
                <option value="multipleChoice">Multiple Choice</option>
                <option value="trueFalse">True/False</option>
                <option value="matching">Matching</option>
              </select>
              <label>Title Image:</label>
              <input
                type="text"
                name="titleImage"
                value={newTopic.titleImage}
                onChange={handleInputChange}
              />
              <div className="modal-buttons">
                <button type="submit" className="blue-button">
                  Save
                </button>
                <button
                  type="button"
                  className="red-button"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-container" style={{ overflowX: "auto", overflowY: "auto", maxHeight: "400px" }}>
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Slug</th>
              <th>Game Type</th>
              <th>Music</th>
              <th>Video</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {topics.map((topic, index) => (
              <tr key={index}>
                <td>{topic.title}</td>
                <td>{topic.slug}</td>
                <td>{topic.gameType}</td>
                <td>{topic.music || "No Music"}</td>
                <td>{topic.video || "No Video"}</td>
                <td>
                  <button
                    className="smalldetails-button"
                    onClick={() => handleDetailsClick(topic)}
                  >
                    Details
                  </button>
                  <button
                    className="smalldelete-button"
                    onClick={() =>
                      setTopics((prev) =>
                        prev.filter((_, i) => i !== index)
                      )
                    }
                    style={{ marginLeft: "8px" }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedTopic && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Topic Details</h3>
            <pre>{JSON.stringify(selectedTopic, null, 2)}</pre>
            <button className="blue-button" onClick={handleCloseDetails}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SmartBoardList;